export interface IReferralPhonePartsInput {
  value?: string | null;
  countryCode?: string | null;
  phoneNumber?: string | null;
  localPhoneNumber?: string | null;
  liveInUs?: boolean | null;
}

export interface IReferralPhoneParts {
  countryCode: string;
  phoneNumber: string;
}

const US_COUNTRY_CODE = '1';
const MX_COUNTRY_CODE = '52';
const LOCAL_PHONE_LENGTH = 10;

export function resolveReferralPhoneParts(input: IReferralPhonePartsInput): IReferralPhoneParts {
  const explicitCountryCode = normalizeDigits(input.countryCode);
  const explicitPhoneNumber = normalizeDigits(input.phoneNumber);
  const explicitLocalPhoneNumber = normalizeDigits(input.localPhoneNumber);
  const normalizedValue = normalizeDigits(input.value);
  const countryCode =
    explicitCountryCode ||
    (explicitLocalPhoneNumber ? getDefaultCountryCode(input.liveInUs) : '') ||
    inferInternationalCountryCode(explicitPhoneNumber) ||
    inferInternationalCountryCode(normalizedValue) ||
    getDefaultCountryCode(input.liveInUs);

  if (explicitLocalPhoneNumber) {
    return {
      countryCode,
      phoneNumber: explicitLocalPhoneNumber
    };
  }

  if (explicitPhoneNumber) {
    return {
      countryCode,
      phoneNumber: stripInternationalPrefix(explicitPhoneNumber, countryCode)
    };
  }

  return {
    countryCode,
    phoneNumber: stripInternationalPrefix(normalizedValue, countryCode)
  };
}

function inferInternationalCountryCode(normalizedPhone: string): string {
  if (normalizedPhone.length <= LOCAL_PHONE_LENGTH) {
    return '';
  }

  if (normalizedPhone.startsWith(MX_COUNTRY_CODE)) {
    return MX_COUNTRY_CODE;
  }

  if (normalizedPhone.startsWith(US_COUNTRY_CODE)) {
    return US_COUNTRY_CODE;
  }

  return '';
}

function getDefaultCountryCode(liveInUs?: boolean | null): string {
  return liveInUs ? US_COUNTRY_CODE : MX_COUNTRY_CODE;
}

function stripInternationalPrefix(normalizedPhone: string, countryCode: string): string {
  if (normalizedPhone.length <= LOCAL_PHONE_LENGTH) {
    return normalizedPhone;
  }

  if (countryCode === MX_COUNTRY_CODE && normalizedPhone.startsWith(MX_COUNTRY_CODE)) {
    return normalizedPhone.slice(MX_COUNTRY_CODE.length);
  }

  if (countryCode === US_COUNTRY_CODE && normalizedPhone.startsWith(US_COUNTRY_CODE)) {
    return normalizedPhone.slice(US_COUNTRY_CODE.length);
  }

  return normalizedPhone;
}

function normalizeDigits(value?: string | null): string {
  return (value || '').replace(/[^0-9]/g, '');
}
